import React, { Component } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

const Box = styled.div`
  width: 80%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.img`
  color: rgba(24, 12, 12, 1);
  /* padding: 5px; */
  height: 40px;
`;

const Desc = styled.div`
  display: flex;
  text-align: center;
  line-height: 1.4;
  font-weight: 400;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  font-size: 16px;
  color: rgba(24, 12, 12, 0.7);
  /* font-family: "Jua", sans-serif; */
`;

const Brunch = styled.a`
  margin-top: 15px;
  opacity: 0.7;
  font-size: 14px;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

class Header extends Component {
  render() {
    const { stage, title, desc } = this.props;
    return (
      <Container>
        <Box>
          <Title src={title}></Title>
          {desc === "" ? (
            ""
          ) : (
            <Desc>
              {desc}
              {stage === "0" ? (
                <Brunch
                  href="https://brunch.co.kr/@vicotorlee/105"
                  target="_blank"
                >
                  더 알아보기
                </Brunch>
              ) : (
                ""
              )}
            </Desc>
          )}
        </Box>
      </Container>
    );
  }
}

export default Header;
